import { useState, useEffect } from "react";
import { Activity, Shield, Wifi, Cpu } from "lucide-react";

const Header = () => {
  const [time, setTime] = useState(new Date());
  const [sysStatus, setSysStatus] = useState("ONLINE");

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const flickerInterval = setInterval(() => {
      setSysStatus((prev) => (prev === "ONLINE" ? "ACTIVE" : "ONLINE"));
    }, 5000);
    return () => clearInterval(flickerInterval);
  }, []);

  const formatTime = (d) =>
    d.toLocaleTimeString("en-US", { hour12: false }) +
    ":" +
    String(d.getMilliseconds()).padStart(3, "0");

  const formatDate = (d) =>
    d.toLocaleDateString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "2-digit",
    }).toUpperCase();

  return (
    <div
      data-testid="header-bar"
      className="w-full flex justify-between items-start pt-2 px-3 md:px-4 relative z-20 gap-2"
    >
      {/* Left: Branding */}
      <div className="flex flex-col gap-0.5 min-w-0">
        <h1
          data-testid="header-brand-name"
          className="font-heading text-sm sm:text-lg md:text-2xl lg:text-3xl font-black tracking-[0.15em] sm:tracking-[0.2em] uppercase text-cyan-400 text-glow truncate"
        >
          Alpha Global Enterprises
        </h1>
        <div className="hidden sm:flex items-center gap-3 text-[9px] md:text-xs font-mono tracking-widest text-cyan-600">
          <span className="flex items-center gap-1">
            <Shield className="w-3 h-3" />
            SECURE CHANNEL
          </span>
          <span className="flex items-center gap-1">
            <Wifi className="w-3 h-3" />
            CONNECTED
          </span>
        </div>
      </div>

      {/* Right: System Status */}
      <div className="flex flex-col items-end gap-1 shrink-0">
        <div className="flex items-center gap-1.5">
          <StatusBlock
            icon={<Activity className="w-3 h-3" />}
            label="SYS"
            value={sysStatus}
            color="text-emerald-400"
          />
          <div className="hidden sm:block">
            <StatusBlock
              icon={<Cpu className="w-3 h-3" />}
              label="CORE"
              value="NOMINAL"
              color="text-cyan-400"
            />
          </div>
        </div>
        <div
          data-testid="header-timestamp"
          className="font-mono text-[8px] sm:text-[9px] md:text-[10px] tracking-widest text-cyan-500"
        >
          {formatDate(time)} // {formatTime(time)}
        </div>
      </div>

      {/* Bottom border */}
      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-cyan-500/40 to-transparent" />
    </div>
  );
};

const StatusBlock = ({ icon, label, value, color }) => (
  <div
    data-testid={`status-${label.toLowerCase()}`}
    className="flex items-center gap-1.5 bg-cyan-950/30 border border-cyan-500/20 rounded px-2 py-1"
  >
    <span className="text-cyan-500">{icon}</span>
    <span className="font-mono text-[9px] md:text-[10px] tracking-wider text-cyan-600">
      {label}:
    </span>
    <span className={`font-mono text-[9px] md:text-[10px] tracking-wider font-bold flicker ${color}`}>
      {value}
    </span>
  </div>
);

export default Header;
